import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

interface toggleButtonObject {
  rotateIconDeg?: string;
  icon?: string;
  [x: string]: any;
}

@Component({
  selector: 'app-toggle-btn',
  templateUrl: './toggle-btn.component.html',
  styleUrls: ['./toggle-btn.component.scss']
})
export class ToggleBtnComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() objects: toggleButtonObject[];
  @Input() bindProperty: string;
  @Input() labelProperty: string;
  @Input() fillWidth: boolean = false;
  @Input() currentlySelectedObject: object;

  @Output() clicked = new EventEmitter();
  ngOnInit(): void {
    if (!this.labelProperty) {
      this.labelProperty = this.bindProperty;
    }
  }

  onClick(selectedOption: object) {
    // this.selected = selectedBtn;
    this.clicked.emit(selectedOption);
  }
}
